// import('import/js/modaal.min.js');

/* tslint:disable */
interface JQuery {
    modaal(options: any): Object;
}
/* tslint:enable */

jQuery(function($) {
    class Modal {

        static pushState: boolean = true;

        constructor() {
            this.init();
        }

        init() {
            $('.js-modal:not(.modal--small)').each(function() {
                $(this).modaal({
                    after_open: Modal.afterOpenModal.bind(this),
                    background: '#ffffff',
                    overlay_opacity: 0.4,
                });
            });

            $('.js-modal.modal--small').each(function() {
                $(this).modaal({
                    after_open: Modal.afterOpenModal.bind(this),
                    background: '#ffffff',
                    overlay_opacity: 0.4,
                    width: 680,
                });
            });
        }

        static afterOpenModal(): void {
            if (history.pushState) {
                if (Modal.pushState) {
                    history.pushState($(this).attr('href'), null, window.location.href);
                } else {
                    Modal.pushState = true;
                }
            }
            $(document).trigger('reload');
        }

        static closeModalOnEvent(event): void {
            let closed: boolean = false;
            if ($('.modal-content').length > 0) {
                event.preventDefault();
                $('.js-modal').modaal('close');
                closed = true;
            }
        }
    }

    let modaal: Modal = new Modal();
});
